/*
  Case multiples (ROO `attribute.order_multiple`): an input with step="N" (N >= 2) may only
  hold N, 2N, 3N… — plus 0 when its min is 0 (cart lines, where 0 removes the line).
  With step 1 (every product without the metafield) the helpers below behave exactly as
  the old +1 / −1 logic did, and snapQuantity() returns the value untouched.
*/
if ( typeof window.quantityStep !== 'function' ) {

	window.quantityStep = (input) => {
		const step = parseInt(input.getAttribute('step'), 10);
		return Number.isFinite(step) && step > 1 ? step : 1;
	};

	window.quantityBounds = (input) => {
		const min = parseInt(input.getAttribute('min'), 10);
		const max = parseInt(input.getAttribute('max'), 10);
		return {
			min: Number.isFinite(min) ? min : 1,
			max: Number.isFinite(max) ? max : 999
		};
	};

	// Nearest valid multiple of the step, never below one case, never above max.
	// 0 stays 0 only when the input allows it (min 0 — the cart).
	window.snapQuantity = (input, rawValue) => {
		const step = window.quantityStep(input);
		const value = parseInt(rawValue, 10);
		if ( step === 1 ) return Number.isFinite(value) ? value : rawValue;
		const { min, max } = window.quantityBounds(input);
		if ( ! Number.isFinite(value) ) return Math.max(min, step);
		if ( value <= 0 && min <= 0 ) return 0;
		let snapped = Math.round(value / step) * step;
		if ( snapped < step ) snapped = step;
		if ( snapped < min ) snapped = Math.ceil(min / step) * step;
		const top = Math.floor(max / step) * step;
		if ( top >= step && snapped > top ) snapped = top;
		return snapped;
	};

	// The next / previous valid value from `current`. A quantity that is not a multiple
	// (a cart line added before the rule existed) moves to the neighbouring multiple.
	window.quantityNext = (input, current) => {
		const step = window.quantityStep(input);
		return ( Math.floor(current / step) + 1 ) * step;
	};
	window.quantityPrev = (input, current) => {
		const step = window.quantityStep(input);
		return ( Math.ceil(current / step) - 1 ) * step;
	};

}

if ( typeof ProductQuantity !== 'function' ) {

	class ProductQuantity extends HTMLElement {

		constructor(){

			super();

			const qty = this.querySelector('.qty-selector'),
						qtyMinus = this.querySelector('.qty-minus'),
						qtyPlus = this.querySelector('.qty-plus'),
						qtyMin = qty.getAttribute('min') ? parseInt(qty.getAttribute('min')) : 1,
						qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 999;

			const refresh = () => {
				const currentQty = parseInt(qty.value);
				if ( window.quantityPrev(qty, currentQty) < qtyMin ) {
					qtyMinus.classList.add('disabled');
				} else {
					qtyMinus.classList.remove('disabled');
				}
				if ( window.quantityNext(qty, currentQty) > qtyMax ) {
					qtyPlus.classList.add('disabled');
				} else {
					qtyPlus.classList.remove('disabled');
				}
			};

			refresh();

			qty.addEventListener('change', (e)=>{
				// Snap a typed case quantity on commit (blur / Enter), never while typing —
				// snapping on `input` would turn the "1" of "12" into a case before the "2".
				if ( window.quantityStep(qty) > 1 ) {
					const snapped = window.snapQuantity(qty, qty.value);
					if ( String(snapped) !== qty.value ) qty.value = snapped;
				}
				refresh();
			});

			qtyMinus.addEventListener('click', (e)=>{
				e.preventDefault();
				if ( ! qtyMinus.classList.contains('disabled') ) {
					const prevQty = window.quantityPrev(qty, parseInt(qty.value));
					if ( prevQty >= qtyMin ) {
						qty.value = prevQty;
					}
					refresh();
				}
			});

			qtyPlus.addEventListener('click', (e)=>{
				e.preventDefault();
				if ( ! qtyPlus.classList.contains('disabled') ) {
					const nextQty = window.quantityNext(qty, parseInt(qty.value));
					if ( nextQty <= qtyMax ) {
						qty.value = nextQty;
					}
					refresh();
				}
			});

		}

	}


  if ( typeof customElements.get('product-quantity') == 'undefined' ) {
    customElements.define('product-quantity', ProductQuantity);
	}

}
